import { makeRequest, uuidv4 } from './makeRequest';

//==========================================================================================================
//
//                                             SERVER CALLS
//
//==========================================================================================================

// let API_URL = "http://localhost:80/JSON";
var API_URL = "https://fpgoalsserver.azurewebsites.net/JSON";//"https://api.fpgoals.avenirhealth.org/JSON";//"http://api.policytools.avenirhealth.org:8083/JSON";

export const CLIENT_ID = '{' + uuidv4() + '}'; //'{6C21CC11-7AA3-4033-9F85-3511D07B3EAB}';
//const CLIENT_ID_REST = '{' + uuidv4() + '}'; // '{7C21CC11-7AA3-4033-9F85-3511D07B3EAB}';

export const GoalsService = {
    pickCountry: (num, mySuccess) =>
        makeRequest(API_URL, CLIENT_ID, "FPGoalsService.SetCountry", {country: num}, {}, mySuccess),
    changeResults: (a, b, c, d, e, f, g, h, i, j, k, mySuccess) =>
        makeRequest(API_URL, CLIENT_ID, "FPGoalsService.doChangeResultValues", {country: a, Policy: b/100, PPFP: c/100, LARC: d/100, CHW: e/100, MobileOutreach: f/100, Pharma: g/100, Stockout: h/100, Comprehensive: i/100, SBC: j/100, MassMedia: k/100}, {}, mySuccess)
}

export const LoginService = {

    ping : (mySuccess) =>
        makeRequest(API_URL, CLIENT_ID, "GBLoginService.Ping", {}, {}, mySuccess),

    sum : (a, b, mySuccess) =>
        makeRequest(API_URL, CLIENT_ID, "GBLoginService.Sum", {
            A : a,
            B : b
        }, {}, mySuccess),

    signedIn : (mySuccess) =>
        makeRequest(API_URL, CLIENT_ID, "GBLoginService.SignedIn", {}, {}, mySuccess),

    login : (username, password, mySuccess) =>
        makeRequest(API_URL, CLIENT_ID, "GBLoginService.Login", {
            username: username,
            password: password
        }, {}, mySuccess),

    logout : (mySuccess) =>
        makeRequest(API_URL, CLIENT_ID, "GBLoginService.LogOut", {}, {}, mySuccess)
};

export const UserService = {

    ping: (mySuccess) =>
        makeRequest(API_URL, CLIENT_ID, "UNHCRService.Ping", {}, {}, mySuccess),

    sum: (a, b, mySuccess) =>
        makeRequest(API_URL, CLIENT_ID, "UNHCRService.Sum", {
            A: a,
            B: b
        }, {}, mySuccess),

    getUsername: (mySuccess) =>
        makeRequest(API_URL, CLIENT_ID, "UNHCRService.GetUsername", {}, {}, mySuccess),

    getHumanName: (mySuccess) =>
        makeRequest(API_URL, CLIENT_ID, "UNHCRService.GetHumanName", {}, {}, mySuccess),

    getClientID: (mySuccess) =>
        makeRequest(API_URL, CLIENT_ID, "UNHCRService.GetClientID", {}, {}, mySuccess),
};

export const SKService = {

    createProject : (fileTitle, mySuccess) =>
        makeRequest(API_URL, CLIENT_ID, "UNHCRService.CreateProject", {}, {
            FileTile: fileTitle
        }, mySuccess),

    destroyProject : (mySuccess) =>
        makeRequest(API_URL, CLIENT_ID, "UNHCRService.DestroyProject", {}, {

        }, mySuccess),

    openProject : (fileTitle, mySuccess) =>
        makeRequest(API_URL, CLIENT_ID, "UNHCRService.OpenProject", {}, {
            FileTitle: fileTitle
        }, mySuccess),

    saveProject : (fileTitle, mySuccess) =>
        makeRequest(API_URL, CLIENT_ID, "UNHCRService.SaveProject", {}, {
            FileTitle: fileTitle
        }, mySuccess),

    calculateProject : (mySuccess) =>
        makeRequest(API_URL, CLIENT_ID, "UNHCRService.CalculateProject", {}, {}, mySuccess),

    getEditorTable : (editorID, mySuccess) =>
        makeRequest(API_URL, CLIENT_ID, "UNHCRService.GetEditorTable", {}, {
            EditorID: editorID
        }, mySuccess),

    setEditorTable : (editorID, newEditorValues, mySuccess) =>
        makeRequest(API_URL, CLIENT_ID, "UNHCRService.SetEditorTable", {}, {
            EditorID: editorID,
            NewEditorValues: newEditorValues
        }, mySuccess),

    getResultTable : (resultID, mySuccess) =>
        makeRequest(API_URL, CLIENT_ID, "UNHCRService.GetResultTable", {}, {
            ResultID: resultID
        }, mySuccess),

    getResultChart : (resultID, mySuccess) =>
        makeRequest(API_URL, CLIENT_ID, "UNHCRService.GetResultChart", {}, {
            resultID: resultID
        }, mySuccess),

    getModvar : (idList, mySuccess) =>
        makeRequest(API_URL, CLIENT_ID, "UNHCRService.GetModvar", {}, {
            IDList: idList
        }, mySuccess),

    setModvar : (modvars, mySuccess) =>
        makeRequest(API_URL, CLIENT_ID, "UNHCRService.SetModvar", {}, {
            Modvars: modvars
        }, mySuccess),
};


// WEBPACK FOOTER //
// ./src/api/server_calls.js